import { render, staticRenderFns } from "./AudioDetail.vue?vue&type=template&id=1f9e92d0"
import script from "./AudioDetail.vue?vue&type=script&lang=js"
export * from "./AudioDetail.vue?vue&type=script&lang=js"
import style0 from "./AudioDetail.vue?vue&type=style&index=0&id=1f9e92d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports